
import React from 'react';
import Store from '../../redux/store';
import '../../resources/css/notice-page.css';
import i18n from '../../i18n';
import { DefaultRequest } from '../../requests/default.request';
import { withSnackbar, WithSnackbarProps } from 'notistack';
import { MessengerModule } from '../../messenger/module';
import { SpecialDishes } from '../../constants/type.constant';
import _ from 'lodash';
import foodDefaultImage from '../../assets/food.png';
import { preLoadNginxImage } from '../../tools/utils';

class FeaturedDishes extends React.Component<Props, State>{
    public messengerModule: MessengerModule;
    public featuredDishAreaWidth: number = 0;
    constructor(props: Props) {
        super(props);
        this.state = {
            // 特色菜品数据
            specialDishesData: [],
        }
        this.messengerModule = new MessengerModule(this.props.enqueueSnackbar);
    }

    // *********************
    // 生命周期
    // *********************
    public UNSAFE_componentWillMount() {
        // 获取特色菜品
        this.getSpecialDishes();
    }
    public componentDidMount() { }

    // public shouldComponentUpdate(nextProp: any, nextState: State) {
    //     return false
    // }

    // *********************
    // 方法区
    // *********************
    /**
     * 获取特色菜品
     */
    public async getSpecialDishes() {
        try {
            const SPECIALDISHES = await DefaultRequest.getSpecialDishes();
            // console.log(SPECIALDISHES, 'SPECIALDISHES')
            const URL = `${Store.getState().serverUrl}`
            if (Array.isArray(SPECIALDISHES)) {
                for(let i = 0; i< SPECIALDISHES.length; i++) {
                    const item = SPECIALDISHES[i];
                    if (!_.has(item, 'url')) {
                        let dishImg = `${URL}/menu_pic/${item.menu_item_id}_s.jpg`;
                        const newImage = await preLoadNginxImage(dishImg, '/menu_pic', '', true);
                        _.set(item, 'url', newImage || foodDefaultImage)
                    }
                }
                this.setState({ specialDishesData: SPECIALDISHES });
            }
        } catch (error) {
            this.messengerModule.say({
                message: `${i18n.t('general_text_update_faild')}`,
                level: 'Warning',
            })
        }
    }

    // *********************
    // 视图区
    // *********************

    render() {
        const { specialDishesData } = this.state;
        return (
            <React.Fragment>
                {
                    !!specialDishesData.length &&
                    <div className="featured-main">
                        <div className="homeTitle">{i18n.t('auto_open_page_text_featured_dishes')}</div>
                        <div
                            className="featured-item"
                            style={this.featuredDishAreaWidth ? { height: this.featuredDishAreaWidth / 1.6 } : {}}
                        >
                            {
                                specialDishesData.map((item, index) => {
                                    return (
                                        <div className="box"
                                            key={index}
                                            style={{ backgroundImage: `url(${item.url})` }}
                                            ref={(imgAreaRef) => {
                                                const IMG_WIDTH = _.get(imgAreaRef, 'offsetWidth', 0)
                                                if (IMG_WIDTH) this.featuredDishAreaWidth = IMG_WIDTH;
                                            }}>
                                            <div className='box-text'>
                                                {item.item_name1}
                                            </div>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>
                }
            </React.Fragment>
        )
    }

}
export default withSnackbar(FeaturedDishes);

// **********
// TYPE
// **********

type Props = {

} & WithSnackbarProps

type State = {
    specialDishesData: Array<SpecialDishes & { url?: string }>;
}
